if (!customElements.get('quantity-input')) {
  customElements.define(
    'quantity-input',
    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('.quantity__button').forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;
        const button = event.currentTarget;

        if (button.name === 'plus') {
          if (this.input.max && parseInt(this.input.value) >= parseInt(this.input.max)) return;
          this.input.stepUp();
        } else {
          if (parseInt(this.input.value) <= parseInt(this.input.min || 0)) return;
          this.input.stepDown();
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
      }

      onInputChange() {
        this.validateQtyRules();
      }

      validateQtyRules() {
        const value = parseInt(this.input.value);
        const min = parseInt(this.input.dataset.min || this.input.min || 1);
        const max = this.input.max ? parseInt(this.input.max) : null;

        this.querySelector('.quantity__button[name="minus"]').disabled = value <= min;
        if (max) this.querySelector('.quantity__button[name="plus"]').disabled = value >= max;
      }
    }
  );
}
